import { useState } from 'react';

const timeSlots = ['09:00', '10:00', '11:00', '13:00', '14:00', '15:00', '16:00', '17:00'];
const topics = ['Aile Terapisi', 'Çift / Evlilik Danışmanlığı', 'Bireysel Danışmanlık', 'Çocuk & Ergen', 'Cinsel Terapi', 'Boşanma ve Yas'];

export default function AppointmentSection() {
  const [sessionType, setSessionType] = useState<'Online' | 'Yüz yüze'>('Online');
  const [selectedSlot, setSelectedSlot] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!selectedSlot) return;
    setSubmitting(true);
    const form = e.currentTarget;
    const data = new FormData(form);
    data.append('saat', selectedSlot);
    data.append('seans_turu', sessionType);
    const body = new URLSearchParams();
    data.forEach((v, k) => body.append(k, v as string));
    try {
      await fetch('https://readdy.ai/api/form/d737ti4lqq77n94m7dh0', { method: 'POST', body, headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    }
    setSubmitting(false);
  };

  return (
    <section id="randevu" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 md:gap-16 items-start">
          <div>
            <span className="text-xs font-medium tracking-[0.2em] text-gold uppercase mb-3 block">Randevu</span>
            <h2 className="font-serif text-3xl md:text-4xl font-light text-warm-dark mb-5">İlk adımı birlikte atalım</h2>
            <p className="text-warm-mid text-sm leading-relaxed mb-8">Randevu talebinizi bırakın, en kısa sürede sizinle iletişime geçelim. Online veya yüz yüze seans seçeneğiyle size uygun bir program oluşturalım.</p>
            <div className="flex flex-col gap-4">
              {[{ icon: 'ri-map-pin-line', title: 'Yüz Yüze Seans', desc: 'Nişantaşı, İstanbul ofisimizde' }, { icon: 'ri-video-line', title: 'Online Seans', desc: 'Türkiye\'nin her yerinden erişim' }, { icon: 'ri-shield-check-line', title: 'Gizlilik Güvencesi', desc: 'Tüm görüşmeler tamamen gizlidir' }].map(item => (
                <div key={item.title} className="flex items-center gap-4 bg-cream rounded-xl px-5 py-4 border border-cream-deeper">
                  <span className="w-8 h-8 flex items-center justify-center"><i className={`${item.icon} text-gold text-lg`} /></span>
                  <div>
                    <p className="text-sm font-medium text-warm-dark">{item.title}</p>
                    <p className="text-xs text-warm-light">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-cream rounded-2xl p-6 md:p-8 border border-cream-deeper">
            {submitted ? (
              <div className="text-center py-12">
                <div className="w-16 h-16 flex items-center justify-center rounded-full bg-gold/10 mx-auto mb-4"><i className="ri-check-line text-gold text-3xl" /></div>
                <h3 className="font-serif text-xl text-warm-dark mb-2">Talebiniz alındı!</h3>
                <p className="text-warm-mid text-sm">En kısa sürede sizi arayacağız.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} data-readdy-form id="randevu-form" className="flex flex-col gap-4">
                <h3 className="font-serif text-xl text-warm-dark mb-1">Randevu uygunluğunu sorgula</h3>
                <div className="flex gap-2 bg-white rounded-xl p-1 border border-cream-deeper">
                  {(['Online', 'Yüz yüze'] as const).map(type => (
                    <button type="button" key={type} onClick={() => setSessionType(type)}
                      className={`flex-1 py-2 rounded-lg text-xs font-medium transition-colors cursor-pointer whitespace-nowrap ${sessionType === type ? 'bg-gold text-white' : 'text-warm-mid hover:text-warm-dark'}`}>
                      {type}
                    </button>
                  ))}
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label className="text-xs font-medium text-warm-mid mb-1.5 block">Ad Soyad *</label>
                    <input name="ad_soyad" required type="text" placeholder="Adınız Soyadınız" className="w-full px-4 py-2.5 rounded-xl border border-cream-deeper bg-white text-sm text-warm-dark focus:outline-none focus:border-gold" />
                  </div>
                  <div>
                    <label className="text-xs font-medium text-warm-mid mb-1.5 block">Telefon *</label>
                    <input name="telefon" required type="tel" placeholder="0532 000 0000" className="w-full px-4 py-2.5 rounded-xl border border-cream-deeper bg-white text-sm text-warm-dark focus:outline-none focus:border-gold" />
                  </div>
                </div>
                <div>
                  <label className="text-xs font-medium text-warm-mid mb-1.5 block">Danışmanlık Konusu *</label>
                  <select name="konu" required className="w-full px-4 py-2.5 rounded-xl border border-cream-deeper bg-white text-sm text-warm-dark focus:outline-none focus:border-gold cursor-pointer">
                    <option value="">Konu seçin</option>
                    {topics.map(t => <option key={t} value={t}>{t}</option>)}
                  </select>
                </div>
                <div>
                  <label className="text-xs font-medium text-warm-mid mb-1.5 block">Tercih Ettiğiniz Tarih</label>
                  <input name="tarih" type="date" className="w-full px-4 py-2.5 rounded-xl border border-cream-deeper bg-white text-sm text-warm-dark focus:outline-none focus:border-gold cursor-pointer" />
                </div>
                <div>
                  <label className="text-xs font-medium text-warm-mid mb-2 block">Uygun Saat</label>
                  <div className="grid grid-cols-4 gap-2">
                    {timeSlots.map(slot => (
                      <button type="button" key={slot} onClick={() => setSelectedSlot(slot)}
                        className={`py-2 rounded-lg text-xs font-medium transition-colors cursor-pointer whitespace-nowrap border ${selectedSlot === slot ? 'bg-gold text-white border-gold' : 'bg-white text-warm-mid border-cream-deeper hover:border-gold hover:text-gold'}`}>
                        {slot}
                      </button>
                    ))}
                  </div>
                </div>
                <div>
                  <label className="text-xs font-medium text-warm-mid mb-1.5 block">Mesajınız (İsteğe Bağlı)</label>
                  <textarea name="mesaj" rows={3} maxLength={500} placeholder="Bize kısaca durumunuzu anlatabilirsiniz..." className="w-full px-4 py-2.5 rounded-xl border border-cream-deeper bg-white text-sm text-warm-dark focus:outline-none focus:border-gold resize-none" />
                </div>
                <button type="submit" disabled={submitting}
                  className="w-full py-3.5 bg-gold text-white text-sm font-medium rounded-xl hover:bg-gold-dark transition-colors cursor-pointer whitespace-nowrap disabled:opacity-60">
                  {submitting ? 'Gönderiliyor...' : 'Randevu uygunluğunu sorgula'}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}